import { extractLinks } from '@draft-js-plugins/linkify';
import { ContentState, EditorState, Modifier, SelectionState } from 'draft-js';
import { stateToHTML as stateToHTMLBase } from 'draft-js-export-html';
import { filterEditorState } from 'draftjs-filters';

export const stateToHTML = (contentState: ContentState) => {
  if (!contentState.hasText()) return '';

  return stateToHTMLBase(contentState, {
    entityStyleFn: entity => {
      if (entity.getType() === 'LINK') {
        return {
          element: 'a',
          attributes: {
            href: entity.getData().url,
            target: '_blank',
          },
        };
      }
    },
  });
};

export const linkifyTextUrls = (editorState: EditorState) => {
  let newContent = editorState.getCurrentContent();
  const prevSelection = editorState.getSelection();

  newContent.getBlocksAsArray().forEach(contentBlock => {
    const links = extractLinks(contentBlock.getText());
    const blockKey = contentBlock.getKey();

    links?.forEach(({ index, lastIndex, url }) => {
      let entityKey = contentBlock.getEntityAt(index);

      if (entityKey === null) {
        newContent = newContent.createEntity('LINK', 'MUTABLE', { url });
        entityKey = newContent.getLastCreatedEntityKey();
      } else {
        newContent = newContent.replaceEntityData(entityKey, { url });
      }

      const selection = SelectionState.createEmpty(blockKey).merge({
        anchorOffset: index,
        focusOffset: lastIndex,
      });
      newContent = Modifier.applyEntity(newContent, selection, entityKey);
    });
  });

  const newEditorState = EditorState.push(editorState, newContent, 'apply-entity');

  return EditorState.acceptSelection(newEditorState, prevSelection);
};

export const processStateChanges = (editorState: EditorState) => {
  let newEditorState = editorState;
  const lastChangeType = editorState.getLastChangeType();

  // Filter unsupported styles
  if (lastChangeType === 'insert-fragment') {
    newEditorState = filterEditorState(
      {
        styles: ['BOLD', 'ITALIC'],
        blocks: ['unordered-list-item'],
        entities: [
          {
            type: 'LINK',
            attributes: ['url'],
          },
        ],
        maxNesting: 1,
        whitespacedCharacters: ['\n', '\t'],
      },
      newEditorState,
    );
  }

  // Wrap plain text URLs in anchor elements
  newEditorState = linkifyTextUrls(newEditorState);

  return newEditorState;
};
